/** Reflect constant diagonal travel across each wall, including exact corner hits. */
export function dvdPositionAt(seconds: number, width: number, height: number, speed: number) {
  const reflect = (limit: number, velocity: number) => {
    if (limit <= 0) return 0
    const phase = ((limit / 2 + velocity * seconds) % (2 * limit) + 2 * limit) % (2 * limit)
    return phase <= limit ? phase : 2 * limit - phase
  }
  return { x: reflect(width, 110 * speed), y: reflect(height, 77 * speed) }
}
